export default "__VITE_ASSET__CmwJWoeI__"